import React from 'react'
import './LoadingScreen.css'
import logo from '../../../assets/logo.png'

const LoadingScreen = ({
  size = 120,
  minHeight = '40vh',
  fullScreen = false,
}) => {
  const containerStyle = fullScreen
    ? {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'var(--background-dark)',
        zIndex: 9999,
      }
    : { minHeight }

  return (
    <div className="loading-screen" style={containerStyle}>
      <div
        className="logo-container"
        style={{ width: `${size}px`, height: `${size}px` }}
      >
        <img src={logo} alt="" className="logo-background" />
        <img src={logo} alt="" className="logo-colored" />
      </div>
    </div>
  )
}

export default LoadingScreen
